import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text } from "@chakra-ui/react";

import { $string } from "foundation-ts/commons";
import { $trim } from "foundation-ts/strings";

import { G1Button } from "@components/G1Button";
import { AsyncActionModalState } from "@components/Modals/ModalConstants";

export const AsyncActionModal = (props: AsyncActionModalState) => {
    const { title, message, isOpen, disabledConfirm, confirm, cancel, size = 'md', element, onClose, onAccept } = props ;
        
    return (
        <Modal onClose={onClose} size={size} isOpen={isOpen} closeOnEsc={true} isCentered={true}>
            <ModalOverlay backdropFilter="blur(6px)" />
            <ModalContent>
                <ModalHeader>{$string(title)}</ModalHeader>
                <ModalCloseButton />
                <ModalBody><Text whiteSpace='pre-line' fontSize="md">{$string(message)}</Text></ModalBody>
                {element}
                <ModalFooter margin="auto">
                    <Stack direction='row' marginRight="2%" spacing={4} align='left'>
                        <G1Button component="global" variant="cancel" title={$trim(cancel)} type="button" minWidth="100px" onClick={onClose} />
                        <G1Button component="global" variant="normal" title={$trim(confirm)} type="button" minWidth="100px" disabled={disabledConfirm} onClick={onAccept} />
                    </Stack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    ) ;
} ;